export default __webpack_public_path__ + "static/media/phone.e5468f7d.svg";